import Vue from 'vue'
import jquery from 'jquery'

import VueRouter from 'vue-router'
Vue.use(VueRouter)

import routes from '@/routes'
import store from '@/store'

export const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes,
    linkActiveClass: 'active-link'
})

let publicPages = [
    'legal',
    'maintenance',
    'login'
]

router.beforeEach((to, from, next) => {
    if(jquery.inArray(to.name, publicPages) !== -1)
        next()
    else {
        if(!store.state.api.token && to.name !== 'login') {
            let route = {
                name: 'login'
            }
            
            if(to.fullPath !== '/campus')
                route.query = { redirect: to.fullPath }
            
            next(route)
        }
        else if(store.state.api.token && to.name === 'login') {
            next({
                path: '/campus'
            })
        }
        else
            next()
    }
})

Vue.router = router

export default {
    router
}
